<template>
    <div>
        <OlvidoContraseña/>

    </div>
</template>

<script>
import OlvidoContraseña from '@/components/Usuario/ActualizarContraseña.vue'

export default {
    name: 'SolimanologContraseARenovacion',
    components:{
        OlvidoContraseña
    },

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

<style lang="scss" scoped>

</style>